import { Toast } from '../components';

export const handleError = (error: any) => {
  if (error?.errors) {
    Toast(error?.errors);
  }
};

export const maximumGradePerGroup = [3, 1, 2, 1.3, 0.5, 1, 1, 0.5, 0.5, 0.8, 1.5, 0.5];
